<template>
  <div class="pagination" :class="rootClasses">
    <a
      role="button"
      href="#"
      class="pagination-previous"
      :disabled="!hasPrev"
      @click.prevent="prev" >
      <i class="mdi">chevron_left</i>
    </a>
    <a
      role="button"
      href="#"
      class="pagination-next"
      :disabled="!hasNext"
      @click.prevent="next" >
      <i class="mdi">chevron_right</i>
    </a>
    <ul class="pagination-list" v-if="!simple">
      <!--First-->
      <li v-if="hasFirst">
        <a
          role="button"
          href="#"
          class="pagination-link"
          @click.prevent="first">
          1
        </a>
      </li>
      <li v-if="hasFirstEllipsis"><span class="pagination-ellipsis">&hellip;</span></li>

      <!--Pages-->
      <li v-for="page in pagesInRange" :key="page.number">
        <a
          role="button"
          href="#"
          class="pagination-link"
          :class="{ 'is-current': page.isCurrent }"
          @click.prevent="page.click">
          {{ page.number }}
        </a>
      </li>

      <!--Last-->
      <li v-if="hasLastEllipsis"><span class="pagination-ellipsis">&hellip;</span></li>
      <li v-if="hasLast">
        <a
          role="button"
          href="#"
          class="pagination-link"
          @click.prevent="last">
          {{ pageCount }}
        </a>
      </li>
    </ul>
    <small class="info" v-if="simple">
      <template v-if="perPage == 1">
        {{ firstItem }} / {{ total }}
      </template>
      <template v-else>
        {{ firstItem }}-{{ Math.min(current * perPage, total) }} / {{ total }}
      </template>
    </small>
  </div>
</template>

<script>
import Pagination from 'buefy/src/components/pagination/Pagination'

export default {
  name: 'BPagination',
  extends: Pagination
}
</script>

<style lang="scss" scoped>
.pagination-previous {
  order: 1;
}
</style>
